import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import ResearchJournal from './pages/ResearchJournal';
import Booking from './pages/Booking';
import Contact from './pages/Contact';
import ValentineZikkiPortfolio from './pages/ValentineZikkiPortfolio';

// Custom Project Pages
import ProjectSpectrumCreatives from './pages/projects/ProjectSpectrumCreatives';
import ProjectMpenziMashini from './pages/projects/ProjectMpenziMashini';
import ProjectFichuaPaziaUnmask from './pages/projects/ProjectFichuaPaziaUnmask';

import './styles/App.css';
import JournalFichuaPazia from './pages/journal/JournalFichuaPazia';
import JournalMsichanaWaAI from './pages/journal/JournalMsichanaWaAI';
import JournalNeuroArts from './pages/journal/JournalNeuroArts';
import JournalTheatreSustainability from './pages/journal/JournalTheatreSustainability';
import FounderStatement from './pages/FounderStatement';

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/research-journal" element={<ResearchJournal />} />
          <Route path="/workshops-and-training" element={<Booking />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/valentine-zikki" element={<ValentineZikkiPortfolio isPreview={false} />} />
          <Route path="/founder-statement" element={<FounderStatement />} />
          
          {/* Custom Project Routes */}
          <Route path="/project/spectrum-creatives" element={<ProjectSpectrumCreatives />} />
          <Route path="/project/mpenzi-mashini" element={<ProjectMpenziMashini />} />
          <Route path="/project/fichua-pazia-unmask" element={<ProjectFichuaPaziaUnmask />} />
          
          {/* Custom Journal Routes */}
          <Route path="/journal/from-survival-to-sustainability" element={<JournalTheatreSustainability />} />
          <Route path="/journal/fichua-pazia-research" element={<JournalFichuaPazia />} />
          <Route path="/journal/msichana-wa-ai" element={<JournalMsichanaWaAI />} />
          <Route path="/journal/neuro-arts" element={<JournalNeuroArts />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;